import { PAListStore } from "@/Appointments/Stores/PAListStore";
import { Appointment } from "@/Common/Api/Appointment/Dto/Appointment";
import { MyleTableColumn } from "@/Common/Components/Tables/MyleTableColumn";
import { ArrayHelper } from "@/Common/Helpers/ArrayHelper";
import { PAListSortOrderType, SortDirection } from "@/Common/Models/UI/Enums";
import { MyleTableTarget } from "@/Common/Models/UI/Tables/MyleTableTarget";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";

class PAListHandler extends BaseOperationHandler {
    constructor() {
        super();

        this.RegisterOperation(LocalOperations.Calendar.Calendar_PAList_Mounted, this.LoadPAList);
        this.RegisterOperation(LocalOperations.Misc.MyleApp_Container_Click, this.OnContainerClick, false);
        this.RegisterOperation(LocalOperations.Calendar.PAList_Search_TextBoxChanged, this.SearchBoxTextChanged);
        this.RegisterOperation(LocalOperations.Calendar.PAList_LabelPrint_CompleteOne, this.PrintLabelCompleteOne);
        this.RegisterOperation(LocalOperations.Calendar.PAList_LabelPrint_Billing, this.PrintLabelBilling);
        this.RegisterOperation(LocalOperations.Misc.Table_ColumnSortClick, this.SetColumnSort);
    }

    public SetColumnSort(request: LocalEvent, store: PAListStore): void {
        var tableTarget = request.Get<MyleTableTarget>("target");

        if (tableTarget === MyleTableTarget.Myle_Calendar_PAList_SearchResults_ColumnSortClick) {
            var columnOrderType = request.Get<PAListSortOrderType>("sortColumn");

            if (store.PAListModel.get("OrderByColumn") && store.PAListModel.get("OrderByColumn") === columnOrderType) {
                if (store.PAListModel.get("OrderByDirection") === SortDirection.ASC) {
                    store.PAListModel = store.PAListModel.set("OrderByDirection", SortDirection.DESC);
                }
                else {
                    store.PAListModel = store.PAListModel.set("OrderByDirection", SortDirection.ASC);
                }
            }
            else {
                store.PAListModel = store.PAListModel.set("OrderByColumn", columnOrderType);
                store.PAListModel = store.PAListModel.set("OrderByDirection", SortDirection.DESC);
            }

            var column = request.Get<MyleTableColumn>("columnObject");

            if (column) {
                store.PAListModel = store.PAListModel.set("LastColumnOrdered", column.columnOptions.FieldName);

                if (column.columnOptions.IsSortActive) {
                    column.ToggleSortDirection();
                }

                column.columnOptions.IsSortActive = true;

                var isDescending = store.PAListModel.get("OrderByDirection") == SortDirection.DESC;
                var data = store.PAListModel.get("TableData").toArray();
                var sortedData: Appointment[] = [];

                if (column.columnOptions.FieldName == "StartTime") {
                    sortedData = ArrayHelper.SortDynamic(data, "StartTime", isDescending);
                }
                else if (column.columnOptions.FieldName == "PatientFirstName") {
                    sortedData = ArrayHelper.SortDynamic(data, "PatientLastName", isDescending);
                }
                else if (column.columnOptions.FieldName == "AppointmentStateLookupName") {
                    var directionChange = isDescending ? -1 : 1;
                    sortedData = data.sort(a => {
                        if (a.AppointmentStateLookupCode !== "COMPLETED") // "in waiting room"
                            return 1 * directionChange;
                        else
                            return -1 * directionChange;
                    });
                }

                store.PAListModel = store.PAListModel.set("TableData", Immutable.List(sortedData));
            }
        }
    }

    public PrintLabelBilling(request: LocalEvent, store: PAListStore): void {
        var receivedAppointment = request.Get<Appointment>("item");
        store.PAListActions.PrintLabelCompleteOne(receivedAppointment, null, "billing");
    }

    public PrintLabelCompleteOne(request: LocalEvent, store: PAListStore): void {
        var receivedAppointment = request.Get<Appointment>("item");

        store.patientToCompleteWithRamqInfo = receivedAppointment;

        if (!sessionStore.getCurrentEmployee().isActiveSiteMexico()) {
            // if clinic has RAMQ, get family doctor before generating label
            if (sessionStore.clientConfiguration.HasMedfarRAMQ == null || sessionStore.clientConfiguration.HasMedfarRAMQ == true) {
                store.PAListActions.GetFamilyDoctor(receivedAppointment.PatientContactId);
            }
            else {
                store.PAListActions.PrintLabelCompleteOne(store.patientToCompleteWithRamqInfo, null, "completeOne");
            }
        }
    }

    public SearchBoxTextChanged(request: LocalEvent, store: PAListStore): void {
        store.PAListModel = store.PAListModel.set("GlobalPAListSearchText", request.Get<string>("value"));
        store.PAListActions.LoadPAList();
    }

    private LoadPAList(request: LocalEvent, store: PAListStore): void {
        store.loadSitesFromCache();
        store.loadClinicianUICache();

        if (!!cacheStore.UserSettings?.PADisplay) {
            store.LoadPAListDisplaySettings(cacheStore.UserSettings.PADisplay);
        }

        store.PAListActions.LoadPAList();
    }

    private OnContainerClick(request: LocalEvent, store: PAListStore): void {
        if (store.PAListModel.get("ColumnOrderingPopupOpen") === true) {
            store.PAListModel = store.PAListModel.set("ColumnOrderingPopupOpen", false);
            sessionStore.hideGlobalOverlay();
            store.EmitChangeToListeners();
        }
    }
}

export { PAListHandler };
